import React from 'react';
import { renderRichText } from 'gatsby-source-contentful/rich-text';
import { BLOCKS, INLINES } from '@contentful/rich-text-types';
import FFLink from '../../components/FFLink';
import Blockquote from './richTextRenderer/renderOptions/blockquote';
import UnorderedList from './richTextRenderer/renderOptions/unorderedList';
import styles from './BodyText.module.css';

/** @type Object.<string, string> */
const BODY_TEXT_CLASS_MAP = {
  'Subtitle 1': styles.subtitle1,
  'Subtitle 2': styles.subtitle2,
  'Body 1': styles.body1,
  'Body 2': styles.body2,
  Caption: styles.caption,
};

/**
 * @param {FF.ContentfulBodyText} props
 */
const renderText = ({ body, isInline, textType }) =>
  renderRichText(body, {
    renderNode: {
      [BLOCKS.QUOTE]: Blockquote,
      [BLOCKS.UL_LIST]: UnorderedList,
      [BLOCKS.PARAGRAPH]: (node, children) => (
        <p
          className={`${BODY_TEXT_CLASS_MAP[textType]}${
            isInline ? ` ${styles.inline}` : ''
          }`}
        >
          {children}
        </p>
      ),
      [INLINES.HYPERLINK]: (node, children) => (
        <FFLink className={styles.link} url={node.data.uri}>
          {children}
        </FFLink>
      ),
    },
  });

/**
 * @param {FF.ContentfulBodyText} props
 */
export default function BodyText(props) {
  return <>{renderText(props)}</>;
}
